$(function(){
  setupScrollToTarget();
})

function scrollToTarget(tgt){
      var topOffset = tgt.data('scrollupoffset') ? tgt.data('scrollupoffset') : 0;
      $('html, body').animate({
        scrollTop: tgt.offset().top 
          - parseInt(tgt.css('padding-top').replace('px', '')) 
          - parseInt(tgt.css('margin-top').replace('px', '')) 
          - topOffset
          - 50
      },{
        duration: 400,
        easing: 'linear'
      });
}

function setupScrollToTarget(){
  $('.scroll-to-target').each(function(){
    $(this).bind('click', function(e){
      e.preventDefault();
      scrollToTarget($($(this).data('scrolltarget')));
    });
  });
}
